export const tokens = {
    ink: "#0f172a",
    muted: "#475569",
    hint: "#64748b",
    accent: "#3f51b5",
    accentSoft: "#eef1fb",
    accentLine: "rgba(63,81,181,0.28)",
    surface: "#ffffff",
    canvas: "#f1f5f9",
    line: "#e2e8f0",
    ok: "#047857",
    okBg: "#ecfdf5",
    wait: "#b45309",
    waitBg: "#fef3c7",
    danger: "#ea5047",
    dangerBg: "#fbe9e7",
    dangerLine: "rgba(234,80,71,0.35)",
    off: "#64748b",
    offBg: "#eef1f4",
    shadow: "0 1px 2px rgba(15,23,42,0.05), 0 8px 24px rgba(15,23,42,0.06)",
};
